import React from "react";

export const HideFeature = ({ children, fallback, hide }: { hide: boolean; children: React.ReactElement | null; fallback?: React.ReactNode }) => {
  if (hide) return fallback ?? null;
  return children;
};
